"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrganizationsService = void 0;
//ANGULAR2 BITS
const core_1 = require("@angular/core");
const Subject_1 = require("rxjs/Subject");
//EXTERNAL LIBRARY BITS
const token_service_1 = require("./token.service");
//INTERNAL LIBRARY BITS
const notification_service_1 = require("./notification.service");
//VARIABLE MODELS
const organization_1 = require("./organization");
let OrganizationsService = class OrganizationsService {
    constructor(_http, _talk) {
        this._http = _http;
        this._talk = _talk;
        this.organizationsObservable = new Subject_1.Subject();
        //initializations
        this.organizationURL = "/organization";
    }
    get() {
        return this.organizations;
    }
    getObservable() {
        return this.organizationsObservable.asObservable();
    }
    getOrgById(id) {
        for (let o in this.organizations) {
            if (this.organizations[o].id == id) {
                return this.organizations[o];
            }
        }
        console.log('ORGANIZATION NOT FOUND: ' + id);
    }
    getOrgByDisplayName(displayName) {
        for (let o in this.organizations) {
            if (this.organizations[o].displayName == displayName) {
                return this.organizations[o];
            }
        }
        console.log('ORGANIZATION NOT FOUND: ' + displayName);
    }
    pull() {
        return this._http.get(this.organizationURL)
            .toPromise()
            .then(response => organization_1.Organization.serializeCollection(response.json()))
            .then(organizations => {
            this.organizations = organizations;
            this.organizationsObservable.next({ organizations: this.organizations });
        })
            .catch(this._talk.handle);
    }
};
exports.OrganizationsService = OrganizationsService;
exports.OrganizationsService = OrganizationsService = __decorate([
    (0, core_1.Injectable)(),
    __metadata("design:paramtypes", [token_service_1.TokenService,
        notification_service_1.NotificationService])
], OrganizationsService);
//# sourceMappingURL=organizations.service.js.map